import type { AxiosRequestConfig } from 'axios';

import { apiClient } from '@/lib/api-client';

export class BaseRepository {
	protected async httpClient<T = any>(config: AxiosRequestConfig & { raw?: boolean }): Promise<T> {
		const { raw, ...axiosConfig } = config;
		const response = await apiClient.request({
			...axiosConfig,
		});
		return (raw ? response.data : response.data.data) as T;
	}
}

export class NoWalletError extends Error {
	constructor(message: string) {
		super(message);
	}
}
